export const Logo = ({ className = "h-9 w-9" }) => (
  <img src="/img/logo-mark-160.png" alt="" className={`${className} rounded-lg object-cover`} />
);

export const Wordmark = () => (
  <span className="flex items-center gap-2.5" aria-label="BalqisBook">
    <Logo />
    <span className="gold-text text-xl font-bold tracking-tight">BalqisBook</span>
  </span>
);
